<template>
  <component :is="layoutComponent" />
</template>

<script>
import PcLayout from "@/views/pc/Layout.vue";
import MobileLayout from "@/views/mobile/Layout.vue";
import { isMobile } from "@/utils/device";

export default {
  name: "AdaptiveShell",
  computed: {
    layoutComponent() {
      return isMobile() ? MobileLayout : PcLayout;
    },
  },
};
</script>
